import { API } from "../../api";

const AUDIT_BASE = "cooperatives/audit-logs";

export const auditLogApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getAuditLogs: builder.query({
      query: ({
        page = 1,
        per_page = 20,
        from_date,
        to_date,
        action,
      } = {}) => {
        const params = new URLSearchParams({
          guard: "staff",
          page: String(page),
          per_page: String(per_page),
        });
        if (from_date) params.append("from_date", from_date);
        if (to_date) params.append("to_date", to_date);
        if (action) params.append("action", action);
        return `${AUDIT_BASE}?${params.toString()}`;
      },
      transformResponse: (responseData) => {
        const d = responseData?.data;
        return {
          rows: d?.rows ?? [],
          pagination: {
            currentPage: d?.current_page ?? 1,
            lastPage: d?.last_page ?? 1,
            perPage: d?.per_page ?? 20,
            total: d?.total ?? 0,
          },
        };
      },
      providesTags: [{ type: "AuditLog", id: "LIST" }],
    }),
    getAuditLogActions: builder.query({
      query: () => `${AUDIT_BASE}/actions?guard=staff`,
      transformResponse: (res) => res?.data?.actions ?? [],
      providesTags: [{ type: "AuditLog", id: "ACTIONS" }],
    }),
  }),
});

export const { useGetAuditLogsQuery, useGetAuditLogActionsQuery } = auditLogApi;
